import { z } from 'zod'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table'
import { CompanySchema } from '@/schemas/company.schema'
import { useNavigate } from 'react-router-dom'
import { Button } from './ui/button'

interface Props {
    companies: z.infer<typeof CompanySchema>[]
}

export default function CompaniesTable(props: Props) {

    const navigate = useNavigate();

    return <div>
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>Name</TableHead>
                    <TableHead>Number</TableHead>
                    <TableHead>Actions</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {props.companies?.map((company) => (
                    <TableRow key={company.ID}>
                        <TableCell>{company.Name}</TableCell>
                        <TableCell>{company.Number}</TableCell>
                        <TableCell><Button className='cursor-pointer' onClick={() => navigate(`/companies/${company.ID}`)}>Actions</Button></TableCell> 
                    </TableRow>
                ))}
            </TableBody>
        </Table>
        {props.companies.length <= 0 && (
            <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                <p>No Companies available</p>
            </div>
        )}
    </div>
}